var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"badge",class:{
        'badge--danger': _vm.color === 'danger',
        'badge--primary': _vm.color === 'primary',
        'badge--success': _vm.color === 'success',
        'badge--warning': _vm.color === 'warning',
    }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }